import type {TextSize} from '@Components/text';
import type {BrandKitRenameState} from '../../use-brand-kit-rename';

export interface BrandKitRenameFieldProps {
  rename: BrandKitRenameState;
  /** The name's size when it is not being edited; the input inherits whatever type surrounds it. */
  textSize: TextSize;
  /** Added to the field while renaming, so a host can draw it as an input box. */
  fieldClassName?: string;
}

/** Saves the rename in progress. */
export const CONFIRM_RENAME_KEY = 'Enter';

/** Cancels the rename in progress and restores the name the kit had. */
export const CANCEL_RENAME_KEY = 'Escape';
